var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIFGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ebene_1 Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Jury-Tool-NEW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "J2.0_Entry-List_iFDA-Final-Jury_Icons",
    transform: "translate(-581.000000, -1167.000000)",
    fill: "#C48F03",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(515.000000, 1158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-Copy",
    transform: "translate(66.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 L32,32 L0,32 L0,0 L32,0 Z M11.8008344,13.4740126 L6.74761181,13.4740126 L6.74761181,25.266113 L11.8008344,25.266113 L11.8008344,13.4740126 Z M18.5297306,6.73638242 L13.476508,6.73638242 L13.4740126,25.266113 L18.5297306,25.266113 L18.5297306,6.73638242 Z M25.2673607,13.4740126 L20.2116427,13.4740126 L20.2116427,18.5284829 L25.2673607,18.5284829 L25.2673607,13.4740126 Z M9.26299372,6.39949111 C7.68234699,6.4029446 6.40344794,7.68649488 6.4057394,9.26714369 C6.40803702,10.8477925 7.69065719,12.1276244 9.27130726,12.1264797 C10.8519573,12.1253336 12.1327254,10.8436442 12.1327254,9.26299372 C12.1330593,8.50236408 11.830621,7.77288306 11.2921897,7.23562221 C10.7537583,6.69836135 10.0236208,6.3975114 9.26299372,6.39949111 Z M25.2673607,6.73638242 L20.2116427,6.73638242 L20.2116427,11.7908527 L25.2673607,11.7908527 L25.2673607,6.73638242 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIFGold);
export default __webpack_public_path__ + "static/media/iF-Gold.763cc50f31734a69383f16c52ade8d38.svg";
export { ForwardRef as ReactComponent };